var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customize-container"},[_c('button',{class:{
      'customize-button': true,
      disabled: _vm.type === -1,
      active: _vm.type === 0 && _vm.touching
    },on:{"click":_vm.handleClick,"touchstart":_vm.handleTouchStart,"touchend":_vm.handleTouchEnd}},[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2df6a2d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./build/loaders/resource-error-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewComponents/CustomizeButton/CustomizeButton.vue
// module id = null
// module chunks = 